"use strict";
// (C) 2007-2019 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_MOBILE_DEVICE = void 0;
var SCREEN = "only screen";
var ZERO_BREAKPOINT = 0;
var SMALL_BREAKPOINT = 640;
var smallRange = {
    lower: ZERO_BREAKPOINT,
    upper: SMALL_BREAKPOINT,
};
var getQueryMatching = function (range) {
    return SCREEN + " and (min-width:" + range.lower + "px) and (max-width:" + range.upper + "px)";
};
var mobileRange = smallRange;
exports.IS_MOBILE_DEVICE = getQueryMatching(mobileRange);
//# sourceMappingURL=MediaQueries.js.map